import React from 'react';
import './Loading.css';

function Loading() {
  return (
    <div className="loading-container">
      <div className="loading-grid" />

      <div className="loading-card">
        <div className="loading-mark">
          <div className="loading-ring" />
          <div className="loading-crosshair" />
        </div>

        <p className="loading-kicker">RONIN KINETIC ESPORTS</p>

        <div className="loading-copy">
          <h1>Loading RKE.world</h1>
          <p>Syncing events, players, telemetry, and prediction markets.</p>
        </div>

        <div className="loading-progress">
          <div className="loading-progress-bar" />
        </div>

        <div className="loading-status">
          <span>AUTH</span>
          <span>API</span>
          <span>LIVE DATA</span>
        </div>
      </div>
    </div>
  );
}

export default Loading;